import React from 'react';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { PLAN_STATUS_CONFIG, MILESTONE_STATUS_CONFIG, PLAN_TYPE_CONFIG } from '../../utils/planConstants';

interface StatusTagProps {
  status: string;
  type?: 'plan' | 'milestone' | 'planType';
  statusOptions?: { value: string; label: string }[];
  statusColors?: Record<string, string>;
  className?: string;
  style?: React.CSSProperties;
}

const StatusTag: React.FC<StatusTagProps> = ({
  status,
  type,
  statusOptions,
  statusColors,
  className = '',
  style,
}) => {
  const { t } = useTranslation();
  
  // 获取状态配置
  const getStatusConfig = () => {
    if (statusOptions && statusColors) {
      return { options: statusOptions, colors: statusColors };
    }
    
    if (type) {
      switch (type) {
        case 'plan':
          return PLAN_STATUS_CONFIG;
        case 'milestone':
          return MILESTONE_STATUS_CONFIG;
        case 'planType':
          return PLAN_TYPE_CONFIG;
        default:
          break;
      }
    }
    
    // 默认配置
    return {
      options: [],
      colors: {}
    };
  };

  const config = getStatusConfig();

  // 获取状态标签（使用国际化翻译）
  const getStatusLabel = () => {
    // 如果传入了自定义选项，使用自定义标签
    if (statusOptions) {
      const option = config.options.find(option => option.value === status);
      return option ? option.label : status;
    }
    
    // 否则使用国际化翻译
    if (type === 'plan') {
      return t(`planManagement.list.status.${status}`, status);
    } else if (type === 'milestone') {
      return t(`planManagement.detail.milestones.status.${status}`, status);
    } else if (type === 'planType') {
      return t(`planManagement.list.planTypes.${status}`, status);
    }
    
    return status;
  };

  // 获取状态颜色
  const getStatusColor = () => {
    return (config.colors as Record<string, string>)[status] || 'default';
  };

  return (
    <Tag
      color={getStatusColor()}
      className={`status-tag ${className}`}
      style={style}
    >
      {getStatusLabel()}
    </Tag>
  );
};

export default StatusTag;